export default "__VITE_ASSET__dc12d7fc__"